// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"853ad66f","253":"7de10808","524":"ac2b0f95","658":"c7c67d3e"}[chunkId] + ".chunk.css";
};